export const CEF_SHARP_EMBEDDED_CLIENT_UPDATE_REJECTION =
  /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:update, ParamCount:\d+$/;

export const CLIENT_SENTRY_SEND_DEFAULT_PII = false;

export const CLIENT_SENTRY_REPLAY_PRIVACY = {
  maskAllText: true,
  blockAllMedia: true,
} as const;
